import { synapse } from '@ublique/platform'

export const initialState = {
  pageSize: 10000,
  table: {
    items: null,
    metadata: null
  },
  selection: {
    selectAll: false,
    excluded: {},
    included: {},
    count: 0,
    total: 0
  }
}

export const spaceOccupancyStore = synapse.store(initialState)

export const reducers = {
  onChangeSelectAll: (updatedData, prevState) => ({
    ...prevState,
    selection: {
      ...prevState.selection,
      ...updatedData
    }
  }),
  onRowSelection: (updatedData, prevState) => ({
    ...prevState,
    selection: {
      ...prevState.selection,
      ...updatedData
    }
  })
}

export const selectors = {
  getSelection: (state) => state.selection,
  getItems: (state) => state.table.items
}

export default {
  spaceOccupancy: spaceOccupancyStore
}
